module.exports = __webpack_public_path__ + "img/logo_agen_black.1ae5ed57.png";